import React from "react";
import { useWarehouseContext } from "./WarehouseProvider";
import { WeightCapture } from "./components/WeightCapture";
import controlWeightIcon from "./images/control-weight-icon.png";

const TITLE = "Weigh Control Container";
const MAX_CONTROL_CONTAINER_WIGHT_KG = 3;

export const ControlWeightCapture = () => {
  const { controlWeight, setControlWeight } = useWarehouseContext();

  return (
    <WeightCapture
      title={TITLE}
      instruction={
        <div className="flex items-center flex-col">
          <div className="whitespace-nowrap">
            Ensure that the only item on the scale is the control container.
            This control
          </div>
          <div className="whitespace-nowrap">
            container must be used for <strong>ALL</strong> weighing operations
            for this Trade-In.
          </div>
        </div>
      }
      icon={controlWeightIcon}
      iconAlt="Control Weight"
      value={controlWeight}
      maxValue={MAX_CONTROL_CONTAINER_WIGHT_KG}
      onChange={setControlWeight}
      showRejectButton={false}
    />
  );
};

ControlWeightCapture.title = TITLE;
